<template>
  <div class="animated fadeIn">
    <h4 class="text-center w-100 text-primary mt-4">
      <i class="fa fa-search pr-2"></i>Nueva Búsqueda
    </h4>
    <b-card :class="[show ? 'w-100' : '', !show ? 'w-75' : '', 'mx-auto']">
      <b-container class="w-100 px-0" v-if="!show">
        <b-form @submit.prevent="store($event)">
          <div class="progress-group">
            <div class="progress-group-header">
              <div>Entidad y Filtros</div>
              <div class="ml-auto font-weight-bold">Paso 2 de 2</div>
            </div>
            <div class="progress-group-bars">
              <div class="progress progress-xs">
                <div
                  class="progress-bar bg-warning"
                  role="progressbar"
                  style="width: 100%"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100">
                </div>
              </div>
            </div>
          </div>
          <b-row class="bg-light px-4 py-4 mx-0">
            <b-col lg="12" md="12">
              <b-row class="py-4 mt-2" align-h="center">
                <b-col lg="5" md="5">
                  <b-button v-for="(field, index) in entityFieldList"
                            :key="index"
                            :variant="isSelected(field) ? 'success' : 'outline-success'"
                            class="mr-1 mb-2"
                            @click="toggleSelection(field)">
                    {{ capitalizeFirstLetter(field.field.name) }}
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row align-h="center">
            <div class="col float-left pt-3">
              <b-form-checkbox class="text-center"
                type="checkbox"
                v-model="saveSearch">
                Guardar Búsqueda
              </b-form-checkbox>
              <button
                type="submit"
                class="btn btn-brand btn-primary btn-lg pull-right"
                :disabled="!validate()">
                Finalizar
              </button>
            </div>
          </b-row>
        </b-form>
      </b-container>
      <b-row md="12" class="pb-3 mx-1" v-if="show">
        <b-card class="w-100">
          <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
            Resultados
            <div>
              <button
                :disabled="count<1"
                class="btn btn-primary btn-sm mr-2"
                @click="exportSearch('')">
                <i class="fa fa-download"></i> Exportar todo
              </button>
              <button
                :disabled="count<1"
                class="btn btn-primary btn-sm mr-2"
                @click="exportSearch('csv')">
                <i class="fa fa-download"></i> CSV
              </button>
              <button
                :disabled="count<1"
                class="btn btn-primary btn-sm"
                @click="exportSearch('xlsx')">
                <i class="fa fa-download"></i> Excel
              </button>
            </div>
          </b-row>
          <v-server-table
            :columns="columns"
            :options="options"
            :theme="theme"
            id="dataTable"
            ref="dataTable"
            md="12"
            lg="12"
            sm="12">
            <template slot="beforeBody">
              <tr v-if="loading">
                <td class="text-center loading" :colspan="15"><spinner size="medium" line-fg-color="#025542" line-bg-color="#c8ced3"></spinner></td>
              </tr>
            </template>
          </v-server-table>
        </b-card>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {request} from '@/helpers/services';
  import Multiselect from 'vue-multiselect';
  import {setupCalendar, DatePicker} from 'v-calendar';
  import {searchFields} from '@/api/search-api';
  import {headingLists} from '@/constants/search-constants';
  import {ServerTable, Event} from 'vue-tables-2';
  import {downloadJsonAsCsv, downloadJsonAsXlsx} from '@/helpers/js-xlsx';
  import form from '@/helpers/form';
  import Spinner from 'vue-simple-spinner';

  import 'v-calendar/lib/v-calendar.min.css';
  Vue.use(ServerTable);
  setupCalendar({
    firstDayOfWeek: 2,
  });

  export default {
    name: 'addFilters',
    components: {
      'v-date-picker': DatePicker,
      Multiselect,
      Spinner
    },
    props: ['query','entity'],
    data: function () {
      return {
        // view
        topmenu: [
          {name: 'Inicio', path: '/admin/dashboard', brand: 'fa fa-home'},
        ],
        title: 'Nueva Búsqueda',
        subtitle: 'Paso 2 de 2',
        entityFieldList: [],
        fieldsList: [],
        saveSearch: false,
        show: false,
        columns: [],
        theme: 'bootstrap4',
        count: 0,
        request: {
          page: 1,
          itemsPerPage: 10
        },
        selectedItems: [],
        result: [],
        loading: true,
        options: {
          headings: headingLists,
          requestFunction: data => {
            this.request.itemsPerPage = data.limit;
            return axios({
              url: '/search/data',
              method: 'post',
              params: this.request,
              data: {entity: this.entity, searchData: this.query, fields: this.fieldsList}

            }).catch(function (e) {
              this.dispatch('error', e);
            }.bind(this));
          },
          responseAdapter({data}) {
            return {
              data: data.searchResult,
              count: data.count
            }
          },
          filterByColumn: false,
          filterable: false,
          sortIcon: {
            base: 'fa',
            up: 'fa-sort-asc',
            down: 'fa-sort-desc',
            is: 'fa-sort'
          },
          perPageValues: [10, 25, 50, 100, 500, 1000, 10000, 100000],
          texts: null,
          pagination: {
            chunk: 10,
            edge: true,
            nav: 'scroll'
          }
        }
      }
    },
    computed: {
    },
    mounted() {
      Event.$on('vue-tables.loading', (data) => {
        this.$_loadingMixin_showLoading();
        this.count = 0;
        this.loading = true;
        if (!!this.$refs.dataTable && !!this.$refs.dataTable.data) {
          this.$refs.dataTable.data = [];
        }
        if (!!document.querySelector('.VueTables__no-results')) {
          document.querySelector('.VueTables__no-results').style.display = 'none';
        }
      });
      Event.$on('vue-tables.loaded', (data) => {
        if (!!data && !!data.data && !!data.data.count) {
          this.count = data.data.count;
        }
        this.$_loadingMixin_hideLoading();
        this.loading = false;
        if (!!document.querySelector('.VueTables__no-results')) {
          document.querySelector('.VueTables__no-results').style.display = 'table-row';
        }
      });
      Event.$on('vue-tables.pagination', (page) => {
        this.request.page = page;
      });
      // this.$eventHub.$emit('captureMenu', this.topmenu);
      this.options.texts = form.tableLabels();
      if (this.query) {
        this.getFieldList(this.entity);
      }
    },

    methods: {
      capitalizeFirstLetter: (str) => {
        return str ? str[0].toUpperCase() + str.slice(1) : "";
      },
      async getFieldList(entity) {
        if (
          entity == 'CONSULTA'
          ||
          entity == 'RECIBO'
        ) {
          let entities = [entity, 'SOCIO_NOSOCIO'];

          let data = await searchFields(entities, null);

          this.entityFieldList = data.fields;

          this.$_loadingMixin_hideLoading();
        } else {
          let data = await searchFields(entity, 'single');

          this.entityFieldList = data.fields;
          
          this.$_loadingMixin_hideLoading();
        }
      },
      isSelected(item) {
        return this.selectedItems.includes(item);
      },
      toggleSelection(item) {
        const index = this.selectedItems.indexOf(item);
        if (index === -1) {
          this.selectedItems.push(item);
        } else {
          this.selectedItems.splice(index, 1);
        }
      },
      async store(e) {
        if (e.preventDefault()) {
          return;
        }

        let self = this;
        this.$_loadingMixin_showLoading();
        this.selectedItems.forEach((field, index) => {
          this.fieldsList.push({field: field.field.value})
        });
        if (this.saveSearch) {
          try {
            let response = await axios({
              method: 'post',
              url: '/search',
              data: {"entity": this.entity, "searchData": this.query, "fields": this.fieldsList}
            });
            if(response && response.status == "201"){
              self.setPartner(response);
              self.setTableData(response);
              this.$_loadingMixin_hideLoading();
              this.$router.push({name: 'listSearch'});
            }
          } catch (error) {
            this.$_loadingMixin_hideLoading();
          }
        } else {
          this.fieldsList.forEach((field, index) => {
            this.columns.push(field.field)
          });
          this.show = true;
          this.$_loadingMixin_hideLoading();
          if (!!this.$refs.dataTable) {
            this.$_loadingMixin_hideLoading();
            this.$refs.dataTable.refresh();
          }
        }

      },
      validate() {
         return true;
      },
      normalizeSearch(data) {
        let myobj = {};
        for (const key in data) {
          Object.assign(myobj, {[`${headingLists[key]}`]: data[key]});
        }
        return myobj;
      },
      async exportSearch(format) {
        if (this.count > 0) {
          this.$_loadingMixin_showLoading();

          let response = await axios({
            method: 'post',
            url: '/search/data',
            params: {
              page: 1,
              itemsPerPage: this.count
            },
            data: {entity: this.entity, searchData: this.query, fields: this.fieldsList}
          });

          let self = this;
          let rows;
          rows = response.data.searchResult.map(function (data) {
              return self.normalizeSearch(data);
          });

          if (format === 'csv') {
            downloadJsonAsCsv(rows);
          } else if (format === 'xlsx') {
            downloadJsonAsXlsx(rows);
          } else {
            downloadJsonAsXlsx(rows)
          }

          this.$_loadingMixin_hideLoading();
        }
      },
      setPartner(entity) {
        this.$emit('sendQuery', entity);
      },
      setTableData(entity) {
        this.$emit('sendTable', entity)
      }
    }
  }
</script>
<style lang="scss">
  #dataTable {
    width: 100%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .vue-title {
      text-align: center;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }

    .VueTables__search-field input {
      margin-left: 0.25rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }

    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

  .fit {
    width: 25px;
    white-space: nowrap;
  }

  .VueTables__no-results {
    display: none;
  }
</style>
